<section class="customer-stories pt-5 pb-5" *ngIf="customerStoriesList?.length>0" >
  <div class="container">
    <div class="content-heading d-flex align-items-center justify-content-between mb-4">
      <h1 class="page-sub-title cv-text-dark">Dealer Stories</h1>
      <a href="#" class="view-more" [routerLink]="'/customer-stories'"(click)="dealerFunction()" >View All
        <img [src]="environment1 + 'images/new-images/arrow.svg'" alt="arrow">
      </a>
    </div>
    <div class="row g-4 d-md-flex">
      <ng-container *ngIf="customerStoriesList?.length == 0 || !productLoaded; else loadingContentttt">
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4" *ngFor="let item of skeletonService.generateFake(3);let i = index;">
            <div class="card border-0 custStory h-100">
              <div class="card-img-top ">
                <ngx-skeleton ></ngx-skeleton>
              </div>
              <div class="card-body pt-4 pb-4">
                <ngx-skeleton height="40px"></ngx-skeleton>
              </div>
            </div>
          </div>
      </ng-container>

      <ng-template #loadingContentttt>
        <owl-carousel-o [options]="customerstoriesoption">
          <ng-container  *ngFor="let item of customerStoriesList" >
            <ng-template carouselSlide [id]="item?.yt_url">

              <div class="col-12" data-bs-toggle="modal" data-bs-target="#fetchOnn_price"  (click)="vedioModal(item.yt_url)" style="cursor: pointer;">
                <div class="card border-0 custStory h-100">
                  <div class="card-img-top hideImg">
                    <img src="{{item?.image_url}}" alt="{{item?.name}}" class="img-fluid" loading="lazy">
                  </div>
                  <div class="ratio  ratio-16x9 hideVideo" style="width: 100%; height: 234px;" data-bs-toggle="modal">
      
                    <ngx-lite-youtube [videoId]="getURL(item?.yt_url)"></ngx-lite-youtube>
                  </div>
                  <div class="card-img-overlay hideImg">
                    <a class="play-icon" data-bs-toggle="modal" data-bs-target="#fetchOnn_price"  (click)="vedioModal(item.yt_url)">
                      <img [src]="environment1 + 'images/new-images/play-icon.svg'" alt="play-icon" loading="lazy">
                    </a>
                    <div class="quote">
                      <img [src]="environment1 + 'images/new-images/blueline.svg'" alt="blueline" loading="lazy">
                    </div>
                  </div>
      
                  <div class="card-body pt-4 pb-4">
                    <h5 class="fw-bold">{{item?.designation}}</h5>
                    <p class="mb-0">{{item?.name}}</p>
                  </div>
                </div>
              </div>
        </ng-template>
        </ng-container>
            </owl-carousel-o>
      </ng-template>


    </div>

  </div>

  <div class="modal modal-fetch-price fetchOnn_price" id="fetchOnn_price" data-bs-keyboard="false" tabindex="-1" aria-labelledby="fetchOnn_priceLabel" aria-hidden="true" (hidden.bs.modal)="closeVideoModal()">
    <div class="modal-dialog modal-dialog-scrollable modal-lg">
      <div class="modal-content  model-contentformobile  border-0">
        <div class="modal-body p-0">
          <button type="button" class="btn-close close-button" data-bs-dismiss="modal" aria-label="Close" (click)="closeVideoModal()"></button>
          <div class="col-12 col-sm-12">
            <div class="card border-0 custStory h-100">
              <div class="ratio ratio-16x9">
                <!-- <iframe *ngIf="videoUrl" [src]="videoUrl" frameborder="0" allowfullscreen ></iframe> -->
                <ngx-lite-youtube *ngIf="videoUrl" [videoId]="getURL(videoUrl)"></ngx-lite-youtube>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</section>
